import { Tournament } from "@portal-frontend-ssr/blast-api";
import { AdaptiveLink } from "@portal-frontend-ssr/ui";
import classNames from "classnames";
import { useMemo, useRef } from "react";
import { generateTournamentLink } from "~/shared/helpers/tournaments/generateTournamentLink";
import { sortTournamentPrizes } from "./helpers/sortTournamentPrizes/sortTournamentPrizes";
import { useDraggable } from "react-use-draggable-scroll";

export const TournamentTabs = ({
  tournament,
  circuitTournaments,
}: {
  tournament: Tournament;
  circuitTournaments: Tournament[];
}) => {
  const tabsContainerRef = useRef<HTMLElement>() as React.MutableRefObject<HTMLInputElement>;
  const { events } = useDraggable(tabsContainerRef);

  // Filters tournaments upon their grouping. We only want tournaments with the same grouping
  const filteredTournaments = useMemo(() => {
    const tournamentGrouping = tournament.grouping ?? null;
    if (!tournamentGrouping) return [];

    return circuitTournaments.filter((item) => item.grouping === tournamentGrouping);
  }, [tournament, circuitTournaments]);

  // Sorts the prize pools from highest to lowest
  // We need Regex parsing, to go from "$50,000.50" to 50000.50
  const sortedFilteredTournaments = useMemo(() => {
    return sortTournamentPrizes(filteredTournaments);
  }, [filteredTournaments]);

  if (sortedFilteredTournaments.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {/* Title */}
      <span className="text-white font-style-body-b3">Regions</span>
      <div className="flex flex-row gap-1 overflow-x-scroll scrollbar-none" ref={tabsContainerRef} {...events}>
        {sortedFilteredTournaments.map((item) => (
          <AdaptiveLink
            key={item.id}
            to={generateTournamentLink({
              gameId: item.circuit.gameId,
              tournamentId: item.id,
            })}
            className={classNames(
              "flex h-9 place-items-center whitespace-nowrap rounded-full border px-4 transition-all font-style-body-b3 sm:px-6",
              {
                "border-background-80 bg-background-100 text-neutral hover:border-neutral hover:text-foreground-90":
                  item.region !== tournament.region,
                "border-foreground-100 bg-background-90 text-foreground-100 hover:border-foreground-100":
                  item.region === tournament.region,
              },
            )}
          >
            {item.region}
          </AdaptiveLink>
        ))}
      </div>
    </div>
  );
};
